import { ref } from '@vue/composition-api'
import invoicesApi from '@/services/api/invoices'

function mapInvoice(inv) {
  return {
    id: inv.id,
    date: inv.date != null ? inv.date : '',
    draftName: inv.draft != null ? inv.draft.name : '',
    number: inv.invoice_number,
    total: inv.total_cost != null ? inv.total_cost.toFixed(2) : '0.00',
    needToPay: inv.need_to_pay,
    pdfUrl: inv.pdf_url,
    canGeneratePdf: inv.can_generate_pdf,
    isOutgoing: inv.is_outgoing,
    committee: inv.committee,
    invoiceType: inv.invoice_type,
    paymentType: inv.payment_type,
    paidAmount: inv.paid_amount != null ? inv.paid_amount.toFixed(2) : '0.00',
    paymentStatus: inv.payment_status
  }
}

export default function useInvoicesList() {
  const invoices = ref([])
  const page = ref(1)
  const totalPages = ref(1)
  const loading = ref(false)
  const selectedInvoice = ref(null)

  async function fetchInvoices(p) {
    if (p != null) page.value = p
    loading.value = true
    try {
      const res = await invoicesApi.getInvoices({ page: page.value })
      const d = res.data
      invoices.value = (d.data != null ? d.data : []).map(mapInvoice)
      const meta = d.meta != null ? d.meta : {}
      page.value = meta.current_page != null ? meta.current_page : 1
      totalPages.value = meta.last_page != null ? meta.last_page : 1
    } catch (_) {
      invoices.value = []
    } finally {
      loading.value = false
    }
  }

  function openStripeForm(invoice) {
    selectedInvoice.value = invoice
  }

  function closeStripeForm() {
    selectedInvoice.value = null
  }

  const generatingPdfIds = ref(new Set())

  async function generatePdf(invoiceId) {
    if (generatingPdfIds.value.has(invoiceId)) return
    generatingPdfIds.value = new Set([...generatingPdfIds.value, invoiceId])
    try {
      const res = await invoicesApi.getPdf(invoiceId)
      const url = res.data.data.url
      if (!url) return
      window.open(url, '_blank')
      const item = invoices.value.find(i => i.id === invoiceId)
      if (item) item.pdfUrl = url
    } catch (_) { // handled by http interceptor
    } finally {
      const next = new Set(generatingPdfIds.value)
      next.delete(invoiceId)
      generatingPdfIds.value = next
    }
  }

  return {
    invoices,
    page,
    totalPages,
    loading,
    selectedInvoice,
    fetchInvoices,
    openStripeForm,
    closeStripeForm,
    generatePdf,
    generatingPdfIds
  }
}



// WEBPACK FOOTER //
// ./src/composables/invoices/useInvoicesList.js